import { render, staticRenderFns } from "./ListaProspectos.vue?vue&type=template&id=5f713d0a&scoped=true"
import script from "./ListaProspectos.vue?vue&type=script&lang=js"
export * from "./ListaProspectos.vue?vue&type=script&lang=js"
import style0 from "./ListaProspectos.vue?vue&type=style&index=0&id=5f713d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f713d0a",
  null
  
)

export default component.exports